import log from 'lib/log'
import AsyncPage from 'pages/AsyncPage'
import { isFollowingTags } from 'actions/follow'
import { loadTaggedPosts } from 'actions/posts'

import universal from 'react-universal-component'
const component = universal(props => import('./HomeNewsTagPostsPage.js'))

const containsTag = ({ values }, tag) => {
  return values && values.length && values.find(t => t._id === tag)
}

class AsyncHomeNewsTagPostsPage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    const {
      session: { value: profile } = {},
      location: { payload: { tag } }
    } = getState()

    try {
      // collect posts tagged x and visible to current user
      const posts = await loadTaggedPosts({ tag })(dispatch, getState, opts)
    } catch (postsErr) {
      log.error(postsErr)
    }

    if (profile) {
      try {
        // find out if we're following the tag
        const tags = await isFollowingTags({
          entities: [tag],
          followerId: profile._id
        })(dispatch, getState, opts)
      } catch (tagsErr) {
        log.error(tagsErr)
      }
    }
  }
  createPageHeadInfo(getState, opts) {
    try {
      let {
        location: { payload: { tag } },
        instance: { value: { instanceName, domainName } },
        posts: {
          extra: entities,
          map: content,
          list: { loading, error, values: order, range } = {}
        }
      } = getState()
      return {
        title: `content tagged ${tag}`,
        keywords: [tag],
        description: `tag-hub for the tag ${tag}`,
        instance: instanceName,
        domain: domainName,
        type: 'website'
      }
    } catch (e) {
      console.error(e)
    }
  }
}

export default new AsyncHomeNewsTagPostsPage()
